import React, { useState } from 'react'
import { Accordion as AccordionMUI, AccordionDetails, AccordionSummary } from '@material-ui/core'
import AddCircleIcon from '../../assets/icons/add-circle.svg'
import RemoveCircleIcon from '../../assets/icons/remove-circle.svg'

import Footnote from '../footnote/Footnote'
import useStyles from './Accordion.styles'

export default function Accordion ({ content, expandedIndex }) {
  const classes = useStyles()
  const [expanded, setExpanded] = useState('panel' + expandedIndex)

  const handleChange = panel => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false)
  }

  return (
    <div className={classes.root}>
      {content.map(({ disclaimer, title, textLine1, textLine2 }, index) => {
        return (
          <AccordionMUI
            key={index}
            className={expanded === 'panel' + index ? 'accordion-item-active' : 'accordion-item'}
            expanded={expanded === 'panel' + index}
            onChange={handleChange('panel' + index)}
          >
            <AccordionSummary
              expandIcon={
                expanded === 'panel' + index
                  ? (
                    <img src={RemoveCircleIcon} className={classes.icon} alt='remove-circle' />
                    )
                  : (
                    <img src={AddCircleIcon} className={classes.icon} alt='add-circle' />
                    )
              }
              aria-controls='panel1bh-content'
              id='panel1bh-header'
            >
              <div className='accordion-title text-start'>{title}</div>
            </AccordionSummary>
            <AccordionDetails>
              <div className='accordion-text'>{textLine1}</div>
            </AccordionDetails>
            {textLine2 && (
              <AccordionDetails>
                <div className='accordion-text'>{textLine2}</div>
              </AccordionDetails>
            )}
            {disclaimer && (
              <AccordionDetails>
                <Footnote
                  notes={Array.isArray(disclaimer) ? disclaimer : [disclaimer]}
                  omitPadding
                />
              </AccordionDetails>
            )}
          </AccordionMUI>
        )
      })}
    </div>
  )
}
